import QuotingServices from "../../services/QuotingServices";

const state = {
    loadingQuoting: false,
    quoteers: []
};

const getters = {
    quoteers: state => {
        return state.quoteers;
    },
    loadingQuoting: state => {
        return state.loadingQuoting;
    }
};

const actions = {
    quoteers(context) {
        context.commit("showLoadingIndicator");
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        return QuotingServices.all(profile, agencyId)
            .then(res => {
                context.commit("quoteers", res.data.data);
            })
            .finally(res => {
                context.commit("hideLoadingIndicator");
            });
    },

};

const mutations = {
    showLoadingIndicator(state) {
        state.loadingQuoting = true;
    },
    hideLoadingIndicator(state) {
        state.loadingQuoting = false;
    },
    quoteers(state, quoteers) {
        state.quoteers = quoteers.sort((a, b) => {
            return a.name > b.name;
        });
        state.loading = false;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};